
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  name="loadingHistorial"
  size="medium"
  color="#fff"
  type="ball-rotate"
  [fullScreen]="true"
  ><p style="color: white">Cargando Historial...</p></ngx-spinner
>
<!-- <div class="container-fluid" > -->
<div class="" style="height: 100%; margin: 0;"> 
<!-- <div> -->
    <div class="navbar-app">


        <nav class="navbar navbar-expand-sm">
          <div class="container-fluid no-x-padding" style="align-items: stretch; height: 100%" >
            <div class="d-flex align-items-center">
              <div class="gl-logo">
                <a class="navbar-brand d-grid" style="margin: 0px">
                  <img [src]="logo" />
                </a>
              </div>
            </div>
          </div>
        </nav>


    </div>
    <div class="row map-area-app">

        <div id="panelMonitoreo2">

            <div class="gl-row-underline" style="background-color: var(--gl-body-background-color);" >

                <div class="row">
                    <div class="col-3" style="padding: 0.3rem 2rem;">
                      <label>VEHÍCULO:</label>
                    </div>
                    <div class="col-9" style="padding: 0.3rem 2rem;">
                      <p-dropdown
                        [options]="availableOptionsUnidades"
                        optionLabel="nombre"
                        optionValue="imei"
                        [(ngModel)]="unidadSeleccionada"
                        [showClear]="false"
                        [appendTo]="'body'"
                        (onChange)="changeUnidad()"
                      ></p-dropdown>
                    </div>
                </div>


              <div *ngIf=" unidadSeleccionada!='000000' " class="col-12" style="padding: 0.3rem 1rem;">
                <label>ESTADO: {{estadoPanel}}</label><br>
                <label>LOCALIZACIÓN: {{localizacionPanel}}</label><br>
                <label><div (click)="ubicar_unidad()"><i class="fas fa-eye" style="font-size: 1rem" pTooltip="Ubicación" tooltipPosition="top"></i></div>
                </label>

              </div>


            </div>

            <br *ngIf="config_seguimiento.chk_mostrar_nota">

            <div *ngIf="config_seguimiento.chk_mostrar_nota" class="gl-row-underline" style="background-color: var(--gl-body-background-color);" >
              <div class="col-12" style="padding: 0.3rem 1rem;">
                <label>NOTAS:</label>
              </div>
              <div class="col-12" style="padding: 0.3rem 1rem;">
                {{config_seguimiento.nota}}
              </div>
            </div>

            <br *ngIf="config_seguimiento.chk_historial_ruta">

            <div *ngIf="config_seguimiento.chk_historial_ruta" class="gl-row-underline" style="background-color: var(--gl-body-background-color);" >
                <div class="row">
                    <div class="col-3" style="padding: 0.3rem 2rem;">
                        <label>PERIODO:</label>
                    </div>
                    <div class="col-9" style="padding: 0.3rem 2rem;">
                        {{ config_seguimiento.fecha_desde | date:'yyyy-MM-dd HH:mm:ss' }} - {{ config_seguimiento.fecha_hasta | date:'yyyy-MM-dd HH:mm:ss' }}
                        <!-- {{ config_seguimiento.fecha_desde | date:'yyyy-MM-dd HH:mm:ss-SS' }} -->
                    </div>
                </div>
            </div>
            
            <br *ngIf="config_seguimiento.chk_historial_ruta" >
            <div *ngIf="config_seguimiento.chk_historial_ruta">
              <div
              class="table-content-component-panel-monitoreo h-auto"
              *ngIf="followLinkService.arrayRecorridos.length > 0"
            >
              <div class="" style="overflow-y: auto">
                <p-table
                  [value]="followLinkService.arrayRecorridos"
                  dataKey="key"
                  id="tabla_historial"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 10%"></th>
                      <th style="width: 10%"></th>
                      <th style="width: 36%">Objeto</th>
        
                      <th class="text-center" style="width: 22%">
                        Consumo de Combustible
                      </th>
        
                      <th class="text-center" style="width: 22%">Kilometraje</th>
                      <!--      <th style="width: 9%">
                      </th>
                      <th style="width: 9%" *ngIf="form.chckGrafico">
                      </th> -->
                      <!-- <th pSortableColumn="price">Price <p-sortIcon field="price"></p-sortIcon></th> -->
                      <!-- <th pSortableColumn="category">Category <p-sortIcon field="category"></p-sortIcon></th> -->
                      <!-- <th pSortableColumn="rating">Reviews <p-sortIcon field="rating"></p-sortIcon></th> -->
                      <!-- <th pSortableColumn="inventoryStatus">Status <p-sortIcon field="inventoryStatus"></p-sortIcon></th> -->
                    </tr>
                  </ng-template>
                  <ng-template
                    pTemplate="body"
                    let-recorrido
                    let-expanded="expanded"
                    let-rowIndex="rowIndex"
                  >
                    <tr (click)="clickZoomHistorial(rowIndex)" >
                      <td>
                        <button
                          type="button"
                          pButton
                          pRipple
                          [pRowToggler]="recorrido"
                          class="p-button-text p-button-rounded p-button-plain"
                          [icon]="
                            expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'
                          "
                        ></button>
                      </td>
                      <td class="text-center">
                        <p-checkbox
                          [(ngModel)]="recorrido.mostrarRuta"
                          [binary]="true"
                          inputId="binary"
                          (onChange)="onChkMostrarRuta(rowIndex)"
                        ></p-checkbox>
                      </td>
                      <td>
                        {{ recorrido.nombre }} <br />
                        {{ config_seguimiento.fecha_desde | date:'yyyy-MM-dd HH:mm:ss' }} - <br />
                        {{ config_seguimiento.fecha_hasta | date:'yyyy-MM-dd HH:mm:ss' }}

                      </td>
        
                      <td class="text-center">
                        {{ recorrido.combustibleTotal }}
                      </td>
        
                      <td class="text-center">
                        {{ recorrido.kilometrajeTotal }}
                      </td>
                      <!-- <td>
                        <button
                          type="button"
                          pButton
                          class="p-button-text p-button-rounded p-button-plain"
                          [title]="'Borrar Recorrido'"
                          (click)="clickEliminar(rowIndex, recorrido.key)"
                        >
                          <i class="fa fa-trash-o" aria-hidden="true"></i>
                        </button>
                      </td> -->
                      <!-- <td *ngIf="form.chckGrafico">
                        <button
                          type="button"
                          pButton
                          class="p-button-text p-button-rounded p-button-plain"
                          [title]="'Mostrar Gráfico'"
                          (click)="clickVerGrafico(rowIndex, recorrido.key)"
                        >
                          <i class="fa fa-area-chart" aria-hidden="true"></i>
                        </button>
                      </td> -->
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="rowexpansion" let-recorrido>
                    <tr class="historial-nested-table position-relative">
                      <td
                        [attr.colspan]="recorrido.kilometrajeTotal != '-' ? 5 : 5"
                        class="py-0"
                      >
                        <!-- <td [attr.colspan]="fieldsChanged.fieldName == 'Comments' ? '2' : ''">                                {{fieldsChanged.newValue}}</td> -->
        
                        <div class="panel-izq-table-container2 p-4">
                          <p-table [value]="recorrido.tramas" dataKey="id">
                            <ng-template pTemplate="header">
                              <tr>
                                <!-- <th >Id </th> -->
                                <th style="width: 8%"></th>
                                <th style="width: 32%">Fecha y Hora</th>
        
                                <th class="text-center" style="width: 18%">Comb.</th>
                                <th class="text-center" style="width: 18%">Km.</th>
                                <!-- <th class="text-center" style="width: 25%" *ngIf="recorrido.kilometrajeTotal != '-'" >Kilometraje </th> -->
        
                                <th class="text-center" style="width: 24%">Duración</th>
                                <!-- <th class="text-center" style="width: 8%"> </th> -->
                                <!-- <th >Status <p-sortIcon field="status"></p-sortIcon></th> -->
                                <!-- <th style="width: 4rem"></th> -->
                              </tr>
                            </ng-template>
                            <ng-template
                              pTemplate="body"
                              let-trama
                              let-rowIndex1="rowIndex"
                            >
                              <tr>
                                <!-- <td class="text-center">
                                                <div [title]="trama.tooltip" data-bs-toggle="tooltip" data-bs-placement="top" >
                                                  <img class="icon-car" [src]="trama.icono" [style.height]="trama.icono_height" [style.width]="trama.icono_width"  />
                                                </div>
                                              </td> -->
        
                                <!-- <td>{{rowIndex}}</td> -->
        
                                <!-- <td>{{trama.dt_tracker}}</td>  -->
        
                                <td class="text-center">
                                  <div
                                    [title]="trama.tooltip"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                  >
                                    <img
                                      class="icon-car"
                                      [src]="trama.icono"
                                      [style.height]="trama.icono_height"
                                      [style.width]="trama.icono_width"
                                    />
                                  </div>
                                </td>
        
                                <td (click)="clickLocate(trama, recorrido.key)">{{ trama.trama.dt_tracker }}</td>
        
                                <td
                                  *ngIf="trama.tooltip == 'Movimiento'"
                                  class="text-center"
                                >
                                  {{ trama.trama.combustible_movimiento }}
                                </td>
                                <td
                                  *ngIf="trama.tooltip != 'Movimiento'"
                                  class="text-center"
                                >
                                  -
                                </td>
        
                                <td
                                  *ngIf="trama.tooltip == 'Movimiento'"
                                  class="text-center"
                                >
                                  {{ trama.trama.distancia_movimiento }}
                                </td>
                                <td
                                  *ngIf="trama.tooltip != 'Movimiento'"
                                  class="text-center"
                                >
                                  -
                                </td>
        
                                <!-- <td *ngIf="rowIndex==0" class="text-center"><span>-</span></td>
                                              <td *ngIf="(rowIndex!=0 && rowIndex!=recorrido.tramas.length-1)" class="text-center"><span>{{trama.trama.distancia}} - {{trama.trama.distancia_movimiento}}</span>  </td>
                                              <td *ngIf="(rowIndex!=0 && rowIndex==recorrido.tramas.length-1)" class="text-center"><span>-.</span></td> -->
        
                                <!-- <td *ngIf="recorrido.kilometrajeTotal != '-' && rowIndex==0" class="text-center"><span>-</span></td>
                                              <td *ngIf="recorrido.kilometrajeTotal != '-' && (rowIndex!=0 && rowIndex!=recorrido.tramas.length-1)" class="text-center"><span>{{trama.trama.distancia}}</span>  </td>
                                              <td *ngIf="recorrido.kilometrajeTotal != '-' && (rowIndex!=0 && rowIndex==recorrido.tramas.length-1)" class="text-center"><span>-.</span></td> -->
        
                                <td *ngIf="rowIndex1 == 0" class="text-center">x</td>
                                <td
                                  *ngIf="
                                    rowIndex1 != 0 &&
                                    rowIndex1 != recorrido.tramas.length - 1
                                  "
                                  class="text-center"
                                >
                                  {{ trama.trama.temp }}
                                </td>
                                <td
                                  *ngIf="
                                    rowIndex1 != 0 &&
                                    rowIndex1 == recorrido.tramas.length - 1
                                  "
                                  class="text-center"
                                >
                                  x
                                </td>
        
                                <!-- <td *ngIf="trama.tooltip == 'Movimiento' " class="text-center">
                                                  <button type="button" class="btn-gl-blue btn-dark-hover flex-none" title="Crear geocerca" (click)="add_geocerca_movimineto(trama, trama.trama, recorrido.key)">
                                                      <i class="fa fa-plus" aria-hidden="true"></i>
                                                  </button>
                                              </td>
                                              <td *ngIf="trama.tooltip != 'Movimiento' " class="text-center">-</td> -->
        
                                <!-- <td>{{order.amount | currency:'USD'}}</td> -->
                                <!-- <td><span [class]="'order-badge order-' + order.status.toLowerCase()">{{order.status}}</span></td> -->
                                <!-- <td><p-button type="button" icon="pi pi-search"></p-button></td> -->
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="4">
                                  There are no order for this product yet.
                                </td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
              </div>
            </div>

        </div>
    
    
        <div id="map" ></div>
    </div>
  
</div>
